/** JS getDay(): 0=Sun … 6=Sat */

export function dateToLocalString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseLocalDate(dateString: string): Date | null {
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/** Inclusive range; only dates whose weekday is in `weekdays`. Cap at maxCount. */
export function generateRecurringDates(
  startDateStr: string,
  endDateStr: string,
  weekdays: number[],
  maxCount = 100
): string[] {
  if (!startDateStr || !endDateStr || weekdays.length === 0) return [];

  const start = parseLocalDate(startDateStr);
  const end = parseLocalDate(endDateStr);
  if (!start || !end || end < start) return [];

  const weekdaySet = new Set(weekdays);
  const result: string[] = [];
  const cursor = new Date(start);

  while (cursor <= end && result.length < maxCount) {
    if (weekdaySet.has(cursor.getDay())) {
      result.push(dateToLocalString(cursor));
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return result;
}
